import React from "react";
import {
    Box,
    Grid,
    Typography,
    IconButton,
    useTheme,
    useMediaQuery,
    Container,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import logo from "../assets/images/logo.png";
import carsaleLogo from '../assets/images/carsaleLogo.png';
import ecommerce from '../assets/images/ecommerce.webp';

const PartnerLogos = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const logos = [
        { src: logo, alt: "LicensedTaxi" },
        { src: carsaleLogo, alt: "CarSale" },
        { src: ecommerce, alt: "Coming Soon" },
    ];

    return (
        <Box
            sx={{ backgroundColor: "#e6f2ff", py: 5, textAlign: "center" }}
        >
            <Container>
                <Grid container spacing={4} alignItems="center">
                    {/* Text Section */}
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="h4"
                            sx={{
                                fontWeight: "600",
                                color: theme.palette.secondary.main,
                                mb: 3,
                                textAlign: "center",
                            }}
                        >
                            Trusted by Leading Innovators in Technology & Industry
                        </Typography>
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ maxWidth: 500, mx: "auto", mb: 3 }}
                        >
                            At MC3 Smart Tech, we believe in the power of collaboration and innovation. Over the years, we’ve
                            partnered with some of the world’s most forward-thinking organizations. Together, we drive digital
                            transformation and create cutting-edge solutions that empower industries globally.
                        </Typography>

                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ maxWidth: 500, mx: "auto", mb: 3 }}
                        >
                            From transforming customer experiences in the automotive industry to revolutionizing e-commerce,
                            our partnerships are built on trust, shared values, and a passion for creating impact. Our goal is
                            to continuously evolve with our partners, helping them thrive in an increasingly digital-first world.
                        </Typography>

                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ maxWidth: 500, mx: "auto" }}
                        >
                            As we expand our partnerships, we look forward to collaborating with more industry leaders who
                            share our vision for a smarter, more connected future.
                        </Typography>
                    </Grid>

                    {/* Logo Carousel Section */}
                    <Grid item xs={12} md={6}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 2,
                                overflow: "hidden",
                                position: "relative",
                            }}
                        >
                            {/* Left Arrow */}
                            {!isMobile && (
                                <IconButton
                                    size="large"
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        color: "#00bfff",
                                        "&:hover": { backgroundColor: "rgba(0,191,255,0.1)" },
                                    }}
                                >
                                    <ArrowBackIosIcon />
                                </IconButton>
                            )}

                            {/* Logo Display */}
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: 4,
                                    overflowX: isMobile ? "auto" : "hidden",
                                    paddingBottom: 2,
                                    "&::-webkit-scrollbar": { display: "none" },
                                }}
                            >
                                {logos.map((logo, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            flex: isMobile ? "0 0 auto" : "none",
                                            width: isMobile ? "80px" : "120px",
                                            height: isMobile ? "80px" : "120px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "1px solid #e0e0e0",
                                            borderRadius: "8px",
                                            backgroundColor: "#fff",
                                            transition: "transform 0.3s ease",
                                            "&:hover": {
                                                transform: "scale(1.1)",
                                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                            },
                                        }}
                                    >
                                        <img
                                            src={logo.src}
                                            alt={logo.alt}
                                            style={{
                                                maxWidth: "90%",
                                                maxHeight: "90%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Box>

                            {/* Right Arrow */}
                            {!isMobile && (
                                <IconButton
                                    size="large"
                                    sx={{
                                        position: "absolute",
                                        right: 0,
                                        color: "#00bfff",
                                        "&:hover": { backgroundColor: "rgba(0,191,255,0.1)" },
                                    }}
                                >
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default PartnerLogos;
